import { Entry } from "../craft/section/Entry"
import { Layout } from "../layout"

export const EntryScreen = ({ entry }) => {
  return (
    <Layout>
      <Entry entry={entry} />
    </Layout>
  )
}
